/* @flow */

import React, { Component } from 'react';
import DateTypeSelector from './DateTypeSelector';
import Date from './Date';
import DateRange from './DateRange';
import moment from 'moment';

type Props = {
  data: object,
};

type State = {
  type: string,
  value?: object,
};

const defaultValueForType = type => {
  switch (type) {
    case 'date-range':
    case 'date-time-range':
      return {
        start: moment(),
        end: moment(),
      };
    case 'date':
    case 'date-time':
    default:
      return moment();
  }
};

const parseValueFromData = data => {
  const { type, value, start, end } = data;

  if (type) {
    switch (type) {
      case 'date':
        return moment(value, 'DD/MM/YYYY');
      case 'date-time':
        return moment(value, 'DD/MM/YYYY HH:mm');
      case 'date-range':
        return {
          start: moment(start, 'DD/MM/YYYY'),
          end: moment(end, 'DD/MM/YYYY'),
        };
      case 'date-time-range':
        return {
          start: moment(start, 'DD/MM/YYYY HH:mm'),
          end: moment(end, 'DD/MM/YYYY HH:mm'),
        };
      default:
        return null;
    }
  }

  return null;
};

class CalendarDate extends Component {
  props: Props;
  state: State;

  constructor(props: Props) {
    super(props);

    this.state = {
      type: props.data.type || 'date',
      value: parseValueFromData(props.data),
    };
  }

  onTypeChange = type => this.setState({ type, value: undefined });
  onValueChange = value => this.setState({ value });

  render() {
    const { type } = this.state;

    const renderDateField = () => {
      const value = this.state.value || defaultValueForType(type);

      switch (type) {
        case 'date':
          return <Date value={value} onChange={this.onValueChange} />;
        case 'date-time':
          return (
            <Date value={value} onChange={this.onValueChange} showTimeSelect />
          );
        case 'date-range':
          return <DateRange value={value} onChange={this.onValueChange} />;
        case 'date-time-range':
          return (
            <DateRange
              value={value}
              onChange={this.onValueChange}
              showTimeSelect
            />
          );
        default:
          return null;
      }
    };

    return (
      <div>
        <div className="ui two fields">
          <DateTypeSelector value={type} onChange={this.onTypeChange} />
          {renderDateField()}
        </div>
      </div>
    );
  }
}

export default CalendarDate;



// WEBPACK FOOTER //
// ./src/modules/calendar/components/CalendarDate.js